import { render, staticRenderFns } from "./InputTaoSirForm.vue?vue&type=template&id=1fc19202&scoped=true"
import script from "./InputTaoSirForm.vue?vue&type=script&lang=js"
export * from "./InputTaoSirForm.vue?vue&type=script&lang=js"
import style0 from "./InputTaoSirForm.vue?vue&type=style&index=0&id=1fc19202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc19202",
  null
  
)

export default component.exports